var map = {
	"./logo-full-greenpay.png": "f2b1",
	"./logo-full-mercado_pago.png": "1fc7",
	"./logo-full-nequi.png": "5999",
	"./logo-full-payu.png": "ab0c",
	"./logo-full-visanet.png": "db45",
	"./logo-greenpay.png": "0d43",
	"./logo-mercado_pago.png": "f1be",
	"./logo-nequi.png": "a1cd",
	"./logo-paypal.png": "d631",
	"./logo-payu.png": "aa00",
	"./logo-visanet.png": "6fe7",
	"./logo-whatsapp.png": "9fa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e7dd";